import type { ReactNode } from "react";
import { ConfigProvider, type ThemeConfig } from "./ui/antd";
import { adminIceTheme } from "./admin-appearance";
import { marketingPageForKey } from "./marketing-navigation";
import "./marketing-appearance.css";

const marketingTheme: ThemeConfig = {
  token: { borderRadius: 8, borderRadiusLG: 8, fontSize: 13 },
  components: {
    Button: {
      colorPrimary: adminIceTheme.token!.colorPrimary,
      colorPrimaryHover: adminIceTheme.token!.colorPrimaryHover,
      colorPrimaryActive: adminIceTheme.token!.colorPrimaryActive,
      primaryColor: "#ffffff",
    },
    Table: { headerBg: "#f6f8f9", headerColor: "#40596a", rowHoverBg: "#f2f7f5", cellPaddingBlock: 16 },
    Segmented: { itemSelectedBg: "#e7efec", itemSelectedColor: "#2f6c61" },
  },
};

/** Keep marketing controls and body-mounted business popups out of other workspaces. */
export default function MarketingAppearance({ enabled, page, children }: { enabled: boolean; page: string; children: ReactNode }) {
  if (!enabled || !(marketingPageForKey(page) || ["knowledgeBase", "ai", "mobile"].includes(page))) return children;
  return <ConfigProvider theme={marketingTheme}
    modal={{ className: "marketing-overlay" }}
    drawer={{ className: "marketing-overlay" }}
    select={{ classNames: { popup: { root: "marketing-popup" } } }}
    datePicker={{ classNames: { popup: { root: "marketing-popup" } } }}
    timePicker={{ classNames: { popup: { root: "marketing-popup" } } }}
    dropdown={{ className: "marketing-popup" }}
    popover={{ classNames: { root: "marketing-popup" } }}
    popconfirm={{ classNames: { root: "marketing-popup" } }}>
    <div className={`marketing-surface page-${page}`}>{children}</div>
  </ConfigProvider>;
}
